import React from "react";
import { Box, Layer, Text, Button } from "grommet";

const ArchiveQuestionConfirmationModal = ({
  question,
  onConfirm,
  onCancel,
}) => (
  <Layer modal onEsc={onCancel} responsive={false}>
    <Box pad="medium" gap="small" width="large">
      <Text weight="bold" align="center" size="large">
        Unpublish Question
      </Text>
      <Box gap="small">
        <Text weight="bold">
          Are you sure you want to unpublish this question?
        </Text>
        <Text>
          <Text weight="bold">Question:</Text> {question.question}
        </Text>
        <Text>
          <Text weight="bold">Type:</Text>{" "}
          {question.weight === 1
            ? "Y/N"
            : question.weight === 2
              ? "Range"
              : "Unknown"}
        </Text>
        <Text>
          <Text weight="bold">Course:</Text> {question.course_name}
        </Text>
        <Text>
          <Text weight="bold">Learning Path:</Text>{" "}
          {question.learning_path_name}
        </Text>
      </Box>
      <Box direction="row" justify="end" gap="small" margin={{ top: "medium" }}>
        <Button label="No" onClick={onCancel} />
        <Button label="Yes" primary onClick={onConfirm} />
      </Box>
    </Box>
  </Layer>
);

export default ArchiveQuestionConfirmationModal;
